import { defineMessages } from "@/i18n";
import en from "./en";

export const desktopConnectionHealthMessages = defineMessages(
  "desktop-connection-health",
  en,
);
